import { Formik, FormikHelpers } from 'formik'
import { Button, InputField, Modal } from '../../../../components'
import { addLeavePolicies, UpdateLeavePolicies } from '../../api/index'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { useAppDispatch } from '../../../../redux/hook'
import { LeavesPolicy } from '../../types/index'
import { addLeavePolicy, updateLeavePolicy } from '../../slice/index'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { AddLeavePolicyIProps } from '../../../leavepolicy/types/index'
import { useNavigate } from 'react-router-dom'
import '../../pages/index'

interface PolicyFormValues {
    policyname: string
    holidayDate: string
}

interface RequestBody {
    id?: string
    title: string
    leavePolicyStartDate: string
}

const AddNewPolicy = ({
    show,
    onClose,
    policyCase,
    toUpdatePolicyDetails,
}: AddLeavePolicyIProps) => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const updationPolicyId = toUpdatePolicyDetails?.id

    const formatDate = (dateString: any) => {
        const date = new Date(dateString)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
    }

    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title={
                policyCase === 'Add'
                    ? `${policyCase} New Leave Policy`
                    : `${policyCase} Leave Policy`
            }
            body={
                <Formik
                    initialValues={{
                        policyname:
                            policyCase === 'Edit'
                                ? toUpdatePolicyDetails?.title || ''
                                : '',
                        holidayDate:
                            policyCase === 'Edit'
                                ? formatDate(
                                      toUpdatePolicyDetails?.leavePolicyStartDate
                                  ) || ''
                                : '',
                    }}
                    onSubmit={async (
                        values,
                        actions: FormikHelpers<PolicyFormValues>
                    ) => {
                        try {
                            dispatch(SHOW_LOADER())
                            const requestBody: RequestBody = {
                                title: values.policyname,
                                leavePolicyStartDate: values.holidayDate,
                            }

                            if (policyCase === 'Edit') {
                                requestBody.id = updationPolicyId
                            }

                            const responseRequest = await (policyCase === 'Add'
                                ? addLeavePolicies(requestBody)
                                : UpdateLeavePolicies(requestBody))

                            const response = await responseRequest
                            const newLeavePolicy: LeavesPolicy = {
                                id: response?.data,
                                title: values.policyname,
                                leavePolicyStartDate: values.holidayDate,
                                leavePolicyDetails:
                                    policyCase === 'Add'
                                        ? []
                                        : toUpdatePolicyDetails?.leavePolicyDetails ||
                                          [],
                            }
                            if (response?.status === 200) {
                                dispatch(
                                    SHOW_NOTIFICATION({
                                        message:
                                            policyCase === 'Add'
                                                ? 'Leave Policy added successfully'
                                                : 'Leave Policy updated successfully',
                                        type: 'success',
                                    })
                                )
                                if (policyCase === 'Add') {
                                    dispatch(addLeavePolicy(newLeavePolicy))
                                } else {
                                    dispatch(updateLeavePolicy(newLeavePolicy))
                                }
                            }
                            if (policyCase === 'Add') {
                                navigate(
                                    `/leave-policies/edit/${response.data}`
                                )
                            }
                            onClose(false)
                        } catch (error) {
                            console.error('Error:', error)
                        } finally {
                            dispatch(HIDE_LOADER())
                            actions.setSubmitting(false)
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="bg-green-color calendar">
                                <InputField
                                    type="text"
                                    lable={''}
                                    name="policyname"
                                    value={values.policyname}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.policyname}
                                    touched={touched.policyname}
                                    placeholder={toUpdatePolicyDetails?.title}
                                />
                            </div>
                            <div className="bg-green-color calendar">
                                <InputField
                                    type="date"
                                    name="holidayDate"
                                    lable="Start Date"
                                    value={values.holidayDate}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.holidayDate}
                                    touched={touched.holidayDate}
                                    // placeholder="MM/DD/YYYY"
                                />
                            </div>
                            <div className="footer-block">
                                <Button disabled={isSubmitting} type="submit">
                                    {policyCase === 'Add' ? 'Add' : 'Update'}
                                </Button>
                                <Button
                                    disabled={isSubmitting}
                                    type="button"
                                    variant="outline-success"
                                    onClick={() => onClose(false)}
                                >
                                    CANCEL
                                </Button>
                            </div>
                        </form>
                    )}
                </Formik>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default AddNewPolicy
